
import { Actions, Action } from "./Actions"
import { get_state } from './State'
import { Keys } from './Datastore'
import { Workorder } from "../workorders/Workorder";


let _dispatch_function: any = null;
let _dispatch_batch_function: any = null;
export function dispatch_initializer(dispatch_function: any, dispatch_batch_function: any) {
    _dispatch_function = dispatch_function;
    _dispatch_batch_function = dispatch_batch_function;
};

export function dispatch_action(action: Action): void {
    Dispatcher.dispatch_action(action);
}

export class Dispatcher {

    private batched_actions: Action[]

    public static dispatch(action: string, data: any): void {
        _dispatch_function(action, data);
    }

    public static dispatch_action(action: Action): void {
        _dispatch_function(action.action, action.data);
    }
}
export class BatchedDispatcher {

    private batched_actions: Action[] = [];

    public dispatch(): void {
        let actions: any[] = []
        this.batched_actions.forEach((a: Action) => {
            actions.push([a.action, a.data]);
        })
        _dispatch_batch_function(actions);
    }

    public add_action(action: Action): BatchedDispatcher {
        this.batched_actions.push(action);
        return this;
    }

    public add(action: Action): BatchedDispatcher {
        return this.add_action(action);
    }
}





// WEBPACK FOOTER //
// ./src/ts/redux/Dispatcher.ts